import React from 'react';
import {GradeStatusEnum} from "@/lib/helper/enumType";

function GradeStatusEnumComponent({text}) {

    if (!text || text === 'none') {
        return <span></span>
    }

    return (
        <span className={`rounded-lg px-2 py-1 text-xs ${GradeStatusEnum(text, 'color')}`}>
            {GradeStatusEnum(text)}
        </span>
    );

}

export default GradeStatusEnumComponent;